import { uiText, useUiLanguage } from '@/i18n/interface';
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Target } from 'lucide-react';
import RequirementItem from './RequirementItem';

interface StudentRequirement {
  id: string;
  requirement_name: string;
  completed: boolean;
  completed_date: string | null;
  notes: string | null;
}

interface RequirementsListProps {
  requirements: StudentRequirement[];
  isEligibleForPromotion: boolean;
  onToggleRequirement?: (requirementId: string) => void;
}

const RequirementsList = ({ requirements, isEligibleForPromotion, onToggleRequirement }: RequirementsListProps) => {
  useUiLanguage();
  const totalRequirements = requirements.length;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Target className="h-5 w-5" />
          {uiText("Belt Requirements")}</CardTitle>
        <CardDescription>
          {uiText("Complete these requirements to advance to your next belt level")}</CardDescription>
      </CardHeader>
      <CardContent>
        {totalRequirements === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <Target className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p className="text-lg font-medium mb-2">{uiText("No Requirements Set")}</p>
            <p className="text-sm">
              {uiText("Your instructor will set specific requirements for your current belt level.")}</p>
          </div>
        ) : (
          <div className="space-y-4">
            {requirements.map((requirement, index) => (
              <RequirementItem
                key={requirement.id}
                requirement={requirement}
                index={index}
                isEligibleForPromotion={isEligibleForPromotion}
                onToggle={onToggleRequirement}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RequirementsList;